import keyMirror from 'keymirror';

const jwtActionTypes = keyMirror({
  JWT_TOKEN: null,
});

export default jwtActionTypes;
